import { hexToRGB } from '@famly/stat_ts-utils_hex-to-rgba';
const defaultColor = { r: 0, g: 0, b: 0 };
/**
 * Calculates the Euclidean distance between two hex colors in RGB space.
 *
 * @see https://en.wikipedia.org/wiki/Color_difference
 *
 * @param c1 First color as a hex string
 * @param c2 Second color as a hex string
 * @returns The distance between the two colors
 */
export const colorDistance = (c1, c2) => {
    const { r: r1, g: g1, b: b1 } = hexToRGB(c1) || defaultColor;
    const { r: r2, g: g2, b: b2 } = hexToRGB(c2) || defaultColor;
    return Math.sqrt(Math.pow(r2 - r1, 2) + Math.pow(g2 - g1, 2) + Math.pow(b2 - b1, 2));
};
